<template>
    <div class="error-page">
        <div class="error-page-image">
            <div class="overlay">
                <navbar />
                <h2 class="main-title">Not Found</h2>
            </div>
        </div>
        <div class="error-page-content container">
            <img src="../assets/img/404.webp" alt="404 page" style="width: 50%" />
        </div>
        <custom-footer />
    </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue"
import CustomFooter from "@/components/CustomFooter.vue"

export default {
    name: "ErrorPage",
    components: {
        Navbar,
        CustomFooter,
    },
    data() {
        return {
        };
    },
    methods: {
    },
    mounted() {
    }
};
</script>

<style lang="scss">
.error-page {
    position: absolute;
    z-index: 100;
}

.error-page .error-page-content {
    padding: 0px 50px;
    z-index: -1;
    position: relative;
}

.error-page .error-page-image {
    background-image: url(../assets/img/about-page.1.webp);
    position: relative;
    height: 60vh;
    background-position: 50%;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    opacity: 90%;
}

.error-page .overlay {
    height: 100%;
    width: 100%;
    background: linear-gradient(270deg, #12680156, #15203bb9);
}

.error-page .main-title {
    text-align: center;
    font-weight: bold;
    color: #fff;
    margin-bottom: 60px;

}


@media (min-width: 992px) {
    .error-page .main-title {
        font-size: 50px;
        padding-top: 70px;
    }
}

@media (max-width: 991px) {
    .error-page .main-title {
        font-size: 40px;
        padding-top: 100px;
    }
}
</style>
